import type { MouseEvent as ReactMouseEvent, DetailedHTMLProps, ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import classnames from 'classnames';

import style from './style.scss';

/**
 * Button component which reset style and disable focus on click
 */

type Props = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

const ResetedButton = forwardRef<HTMLButtonElement, Props>(
  ({ type = 'button', className, onMouseDown, ...props }, ref) => {
    const buttonClassName = classnames(style.button, className);
    const handleMouseDown = (event: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => {
      const { currentTarget } = event;
      if (onMouseDown) {
        requestAnimationFrame(() => {
          currentTarget.blur();
        });
        onMouseDown(event);
      }
    };

    return (
      <button
        ref={ref}
        type={type}
        className={buttonClassName}
        onMouseDown={handleMouseDown}
        {...props}
      />
    );
  }
);

ResetedButton.displayName = 'ResetedButton';

export default ResetedButton;
